import { render, staticRenderFns } from "./ResultWindow.vue?vue&type=template&id=db811826&scoped=true&"
import script from "./ResultWindow.vue?vue&type=script&lang=js&"
export * from "./ResultWindow.vue?vue&type=script&lang=js&"
import style0 from "./ResultWindow.vue?vue&type=style&index=0&id=db811826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db811826",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
